import { useMe } from '@studio/api-client';
import { useEffect, useRef } from 'react';
import { track } from '../observability';

/**
 * Fires `session.workspace_loaded` exactly once per session when the user's
 * workspace id first resolves. The ref guard prevents re-firing when the
 * `/api/me` query refetches (window focus, mutation invalidation, etc.).
 *
 * Mount in App.tsx — signed-out users never fire it because `useMe` is
 * idle without a Clerk session, which is exactly what we want for funnel
 * hygiene.
 */
export function useSessionAnalytics(): void {
  const me = useMe();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    if (!me.isSuccess || !me.data?.workspaceId) return;
    fired.current = true;
    track('session.workspace_loaded', { workspaceId: me.data.workspaceId });
  }, [me.isSuccess, me.data?.workspaceId]);
}
